import { IconCalendar16, IconHouseBed16, IconPinMarker16, IconSearch16, IconUsers16 } from '@warp-ds/icons/react';
import { Button } from '@warp-ds/react';
import { formatClientDate, formatShortenedClientDate } from 'shared/util/datetime-fns';
import type { Filters } from '@/domain';
import { formatBedroomText, formatDateRange, formatGuestText, formatLocationText } from '../utils/formatting';

type SearchDetailsProps = {
    filters: Filters;
    openSearchForm: () => void;
};

export const SearchDetails = ({ openSearchForm, filters }: SearchDetailsProps) => (
    <div className="flex flex-row justify-between border-b md:border md:rounded-8 items-center mb-16" data-testid="searchDetails">
        <div className="flex flex-row justify-between items-center py-8 mb-2 md:mb-0 md:p-16 divide-x text-s md:text-m">
            <div className="flex flex-row items-center gap-8 pr-16">
                <IconSearch16 className="md:hidden" aria-hidden />
                <IconPinMarker16 className="hidden md:inline" aria-hidden />
                <span data-testid="searchDetailsDestination">{formatLocationText(filters.city, filters.country)}</span>
            </div>
            <div className="flex flex-row items-center gap-8 px-16" data-testid="searchDetailsDate">
                <IconCalendar16 className="md:inline hidden" aria-hidden />
                <span className="md:inline hidden">{formatDateRange(filters.booking_from, filters.booking_to, formatClientDate)}</span>
                <span className="md:hidden text-s">
                    {formatDateRange(filters.booking_from, filters.booking_to, formatShortenedClientDate)}
                </span>
            </div>
            <div className="hidden md:flex flex-row items-center gap-8 px-16">
                <IconUsers16 aria-hidden />
                <span data-testid="searchDetailsGuests" className="bottom-a align-text-bottom object-bottom">
                    {formatGuestText(filters.no_of_beds_from)}
                </span>
            </div>
            <div className="hidden md:flex flex-row items-center gap-8 px-16">
                <IconHouseBed16 aria-hidden />
                <span data-testid="searchDetailsBedrooms">{formatBedroomText(filters.no_of_bedrooms_from)}</span>
            </div>
        </div>
        <Button
            className="font-bold text-s md:text-m whitespace-nowrap md:px-16"
            data-testid="openSearchFormButton"
            link
            onClick={openSearchForm}>
            Endre søk
        </Button>
    </div>
);
